import { AppError, ErrorCode } from "@/utils/errorHandler";

/**
 * Map Http Status To Error Code.
 */
export function mapHttpStatusToErrorCode(status: number): ErrorCode {
  if (status === 401) {
    return ErrorCode.AUTHENTICATION_ERROR;
  }
  if (status === 403) {
    return ErrorCode.AUTHORIZATION_ERROR;
  }
  if (status === 404) {
    return ErrorCode.NOT_FOUND;
  }
  if (status >= 500) {
    return ErrorCode.SERVER_ERROR;
  }
  return ErrorCode.UNKNOWN_ERROR;
}

export function buildAppErrorFromHttpResponse(
  errorData: { error?: string; message?: string },
  status: number
): AppError {
  const errorCode = mapHttpStatusToErrorCode(status);
  return new AppError(errorData.error || errorData.message || `HTTP ${status}`, errorCode, status);
}

export function shouldAttemptCsrfRetry(
  status: number,
  retryOn403: boolean,
  hasCachedCsrfToken: boolean
): boolean {
  return status === 403 && retryOn403 && hasCachedCsrfToken;
}

export function parseJsonErrorBody(
  response: Response
): Promise<{ error?: string; message?: string }> {
  return response.json().catch(() => ({ error: response.statusText }));
}
